import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
import type { SvgIconProps } from '@mui/material';
import type { Agent } from '@/shared/api/types';

const ICON: Record<Agent, typeof InboxOutlinedIcon> = {
  intake: InboxOutlinedIcon, match: TrackChangesOutlinedIcon,
  call: CallOutlinedIcon, integrity: ShieldOutlinedIcon, evaluate: FactCheckOutlinedIcon,
};

export function AgentIcon({ agent, ...props }: { agent: Agent } & SvgIconProps) {
  const Icon = ICON[agent] ?? InboxOutlinedIcon;
  return <Icon {...props} />;
}
